export default "__VITE_ASSET__BSATaXcA__"